import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';

export class QuantityCounter {
  constructor(holder, inCart = false) {
    this.holder = holder;
    this.quantityUpdateCart = inCart;
  }

  init() {
    // DOM Elements
    this.quantity = this.holder.querySelector(s.selectors$14.quantityHolder);

    if (!this.quantity) {
      return;
    }

    this.field = this.quantity.querySelector(s.selectors$14.quantityField);
    this.buttons = this.quantity.querySelectorAll(s.selectors$14.quantityButton);
    this.increaseButton = this.quantity.querySelector(s.selectors$14.quantityPlusButton);

    // Set value or classes
    this.quantityValue = Number(this.field.value || 0);
    this.cartItemID = this.field.getAttribute('data-id');
    this.maxValue = Number(this.field.getAttribute('max')) > 0 ? Number(this.field.getAttribute('max')) : null;
    this.minValue = Number(this.field.getAttribute('min')) > 0 ? Number(this.field.getAttribute('min')) : 0;
    this.disableIncrease = this.disableIncrease.bind(this);

    // Flags
    this.emptyField = false;

    // Methods
    this.updateQuantity = this.updateQuantity.bind(this);
    this.decrease = this.decrease.bind(this);
    this.increase = this.increase.bind(this);

    this.disableIncrease();

    // Events
    if (!this.quantity.classList.contains(c.classes$U.quantityReadOnly)) {
      this.changeValueOnClick();
      this.changeValueOnInput();
    }
  }

  /**
   * Change field value when click on quantity buttons
   *
   * @return  {Void}
   */

  changeValueOnClick() {
    this.buttons.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();

        this.quantityValue = Number(this.field.value || 0);

        const clickedElement = event.target;
        const isDescrease =
          clickedElement.matches(s.selectors$14.quantityMinusButton) ||
          clickedElement.closest(s.selectors$14.quantityMinusButton);
        const isIncrease =
          clickedElement.matches(s.selectors$14.quantityPlusButton) ||
          clickedElement.closest(s.selectors$14.quantityPlusButton);

        if (isDescrease) {
          this.decrease();
        }

        if (isIncrease) {
          this.increase();
        }

        this.updateQuantity();
      });
    });
  }

  /**
   * Change field value when input new value in a field
   *
   * @return  {Void}
   */

  changeValueOnInput() {
    this.field.addEventListener('input', () => {
      this.quantityValue = this.field.value;
      this.updateQuantity();
    });
  }

  /**
   * Update field value
   *
   * @return  {Void}
   */

  updateQuantity() {
    if (this.maxValue < this.quantityValue && this.maxValue !== null) {
      this.quantityValue = this.maxValue;
    }

    if (this.minValue > this.quantityValue) {
      this.quantityValue = this.minValue;
    }

    this.field.value = this.quantityValue;

    this.disableIncrease();

    document.dispatchEvent(new CustomEvent('theme:cart:update'));

    if (this.quantityUpdateCart) {
      this.updateCart();
    }
  }

  /**
   * Decrease value
   *
   * @return  {Void}
   */

  decrease() {
    if (this.quantityValue > this.minValue) {
      this.quantityValue--;

      return;
    }

    this.quantityValue = 0;
  }

  /**
   * Increase value
   *
   * @return  {Void}
   */

  increase() {
    this.quantityValue++;
  }

  /**
   * Disable increase
   *
   * @return  {[type]}  [return description]
   */

  disableIncrease() {
    this.increaseButton.classList.toggle(
      c.classes$U.isDisabled,
      this.quantityValue >= this.maxValue && this.maxValue !== null
    );
  }

  updateCart() {
    if (this.quantityValue === '') return;

    const event = new CustomEvent('theme:cart:update', {
      bubbles: true,
      detail: {
        id: this.cartItemID,
        quantity: this.quantityValue,
      },
    });

    this.holder.dispatchEvent(event);
  }
}